import React, { useContext } from "react";
import {
  Container,
  Navbar,
  Nav,
  Row,
  Col,
  Dropdown,
  Button,
  Image,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Loader from "./loader";
import { useTranslation } from "react-i18next";
import chevronDownIcon from "../../assets/icons/chevron-down.png";
import chevronUpIcon from "../../assets/icons/chevron-up.png";
import { SeparatorMenu } from "./separatorMenu";
import { ActualLangContext } from "../../contexts/ActualLangContext";
import { MegaMenu } from "./MegaMenu";
import { addItemToMenuOption } from "./menuHardcodedData";

export const MenuUsaMobile = ({
  logo,
  options,
  buttons,
  handleChange,
  checked,
}) => {
  const history = useHistory();
  const { i18n } = useTranslation();

  const { setLang } = useContext(ActualLangContext);

  // Verificar si estamos en la página de índice de soluciones (no mostrar switch de idioma)
  // El toggle SÍ debe aparecer en páginas específicas como /soluciones/adopcion-ia
  const isInSolutionsIndexPage =
    window.location.pathname === "/solutions" ||
    window.location.pathname === "/soluciones";

  // Agregar el hardcodedItem al multipleOptions.data de la primera opción
  const optionsWithHardcoded = addItemToMenuOption(options, { targetIndex: 0 });
  return (
    <div className="d-block d-sm-block d-md-block d-lg-none">
      <Navbar
        expand="lg"
        className="navbar fixed-top navbar-light bg-white p-3"
      >
        <Container fluid className="p-0">
          <Navbar.Brand href={`/`}>
            {logo?.data ? (
              <img
                src={logo.data.attributes.url}
                alt={logo?.data.attributes.alternativeText}
                className="LogoHeader"
              ></img>
            ) : (
              <Loader />
            )}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse
            aria-controls="basic-navbar-nav"
            id="mobileContainer"
            className="justify-content-end"
          >
            <Nav
              className=" justify-content-end containerNavItem mobile"
              activeKey={window.location.pathname}
            >
              {optionsWithHardcoded?.map((option) => {
                return (
                  <React.Fragment key={option.id}>
                    {option.multipleOptions.data.length ? (
                      <>
                        <Dropdown className="custom-dropdown">
                          <Dropdown.Toggle>
                            {option.title}
                            <Image
                              src={chevronDownIcon}
                              alt="arrow icon"
                              className="inactive"
                            />
                            <Image
                              src={chevronUpIcon}
                              alt="arrow icon"
                              className="active"
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <MegaMenu items={option.multipleOptions.data} />
                          </Dropdown.Menu>
                        </Dropdown>
                        <SeparatorMenu />
                      </>
                    ) : (
                      <>
                        <Nav.Link href={option.href}>{option.title}</Nav.Link>
                        <SeparatorMenu />
                      </>
                    )}
                  </React.Fragment>
                )
              })}

              <Row className="rowItem">
                <Col className="d-flex  align-items-center">
                  {buttons?.map((button, index) => (
                    <Button key={index} variant={button.variant} href={button.href}>
                      {button.textButton}
                    </Button>
                  ))}
                </Col>
                {!isInSolutionsIndexPage && (
                  <Col className="d-flex justify-content-end align-items-center switchContainer">
                    <div id="mySwitch">
                      <input
                        type="checkbox"
                        id="switch"
                        checked={checked}
                        onChange={(event) => {
                          handleChange(event);
                          const newLang = checked ? "en" : "es";
                          setLang(newLang);
                          i18n.changeLanguage(newLang);
                          localStorage.setItem("lang", newLang);
                          let newUrl = window.location.pathname;
                          if (newLang === "es") {
                            newUrl = newUrl.replace(/^\/en\//, "/es/").replace(/^\/en-en\//, "/es-es/");
                          } else {
                            newUrl = newUrl.replace(/^\/es\//, "/en/").replace(/^\/es-es\//, "/en-en/");
                          }
                          if (newLang === "en") {
                            newUrl = newUrl.replace("/soluciones/", "/solutions/").replace("/soluciones", "/solutions");
                          } else {
                            newUrl = newUrl.replace("/solutions/", "/soluciones/").replace("/solutions", "/soluciones");
                          }
                          history.push(newUrl);
                        }}
                      />
                      <div className="app">
                        <div className="container-switch d-flex justify-content-center align-items-center">
                          <label id="switchLanguage" htmlFor="switch">
                            <div className="toggle"></div>
                            <div className="language">
                              <p className="english">EN</p>
                              <p className="espanol">ES</p>
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

MenuUsaMobile.propTypes = {
  logo: PropTypes.shape({
    data: PropTypes.shape({
      attributes: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alternativeText: PropTypes.string,
      }).isRequired,
    }),
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      href: PropTypes.string,
      multipleOptions: PropTypes.shape({
        data: PropTypes.arrayOf(PropTypes.object),
      }),
    })
  ),
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      variant: PropTypes.string,
      href: PropTypes.string.isRequired,
      textButton: PropTypes.string.isRequired,
    })
  ),
  handleChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
};
